// import type { I18nContextType } from '@tmsw/powerups.intl.provider';
import { useMemo } from 'react';
import { useI18nContext } from '@tmsw/powerups.intl.provider';

type JsonReturnType = string | number | object | any[] | boolean | null;

type PureTranslateProps = {
  key: string;
  translations: { [key:string] :JsonReturnType }
  ns?: string;
  defaultValue: JsonReturnType;
};

function pureTranslate(props: PureTranslateProps) {
  const { key, translations, ns, defaultValue } = props;
  if (!translations) throw new Error('dict not loaded.');
  let returnVal = defaultValue;
  if (typeof ns !== "undefined" && translations[ns]?.hasOwnProperty(key)) {
    // @ts-ignore
    returnVal = translations[ns][key];
  } else if (translations.hasOwnProperty(key)) {
    returnVal = translations[key];
  }
  return returnVal;
}

export function useTranslate() {
  const ctx = useI18nContext();
  if (!ctx) throw new Error('Missing I18nContext.Provider in the tree');
  return useMemo(() => function translate(key:string, ns?:string, defaultValue:JsonReturnType = null): any {
    return pureTranslate({
      translations: ctx[ctx.defaultNS],
      key,
      ns,
      defaultValue,
    });
  }, [ctx]);
}

export default useTranslate;
